import { useMutation, useQueryClient } from 'react-query';

import type { TVendorCodeCommercialHomeWarranty } from './../../../models/vendor/VendorCodeModels';
import type { TUpdateModel } from '../../../utils/hookUtils';
import QUERYKEYS from '../../../constants/queryKeys';
import { updateVendorCodeCommercialHomeWarranty } from './../../../services/VendorCodesService';

const useUpdateVendorCodeCommercialHomeWarranty =
  (): TUpdateModel<TVendorCodeCommercialHomeWarranty> => {
    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation(updateVendorCodeCommercialHomeWarranty, {
      onSuccess: () =>
        queryClient.invalidateQueries({
          predicate: (query) =>
            query.queryKey === QUERYKEYS.VENDOR_CODES ||
            query.queryKey[0] === QUERYKEYS.VENDORS ||
            query.queryKey[0] === QUERYKEYS.VENDOR_CODES_COMMERCIAL_HOME_WARRANTY,
        }),
    });

    return {
      update: mutate,
      isLoading,
    };
  };

export default useUpdateVendorCodeCommercialHomeWarranty;
